export const CONTENT_SEARCH_NAME = 'contentSearch';
export const SEARCH_DELAY = 300;
export const SUGGEST_DELAY = 200;
export const FILTER_TYPES = {
  TAXONOMY: 'taxonomy',
  STATUS: 'status'
};
